import dayjs from 'dayjs';
export const getLineOption = (list, t)=>{
    const safeList = list || [];
    return {
        tooltip: {
            trigger: 'axis',
            formatter: (params)=>{
                var _params_;
                const item = safeList === null || safeList === void 0 ? void 0 : safeList[params === null || params === void 0 ? void 0 : (_params_ = params[0]) === null || _params_ === void 0 ? void 0 : _params_.dataIndex];
                if (!item) return '';
                const total = Number(item.ai_count || 0) + Number(item.human_count || 0);
                const row = (label, value)=>`
			<div style="display:flex;justify-content:space-between;margin-bottom:4px">
				<span>${label}</span>
				<span style="min-width:100px;text-align:right;font-weight:600">
					${value}
				</span>
			</div>
		`;
                return `
			<div>
				<div style="font-weight:600;margin-bottom:8px;">
					${dayjs(item.date).format('YYYY-MM-DD')}
				</div>
                ${row(t('c_a_total_quantity_processed'), total)}
				${row(t('c_a_ai_processing_quantity'), item.ai_count || 0)}
				${row(t('c_a_processing_quantity'), item.human_count || 0)}
				${row(t('c_a_overview_ai_solution_rate'), item.ai_solve_percent || '0%')}
			</div>
		`;
            }
        },
        legend: {},
        grid: {
            left: 10,
            right: 20,
            bottom: 10,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: safeList.map((item)=>dayjs(item.date).format('MM.DD'))
        },
        yAxis: [
            {
                type: 'value',
                name: t('c_a_Incoming_line_statistics'),
                min: 0,
                position: 'left',
                axisLabel: {
                    formatter: '{value}'
                },
                splitLine: {
                    show: true
                },
                nameGap: 24,
                nameTextStyle: {
                    padding: [
                        0,
                        0,
                        10,
                        0
                    ]
                }
            },
            {
                type: 'value',
                name: t('c_a_overview_ai_solution_rate'),
                min: 0,
                position: 'right',
                axisLabel: {
                    formatter: '{value}%'
                },
                splitLine: {
                    show: false
                },
                nameGap: 24,
                nameTextStyle: {
                    padding: [
                        0,
                        0,
                        10,
                        0
                    ]
                }
            }
        ],
        series: [
            /** AI处理（底层） */ {
                name: t('c_a_ai_processing_quantity'),
                type: 'bar',
                stack: 'total',
                data: safeList.map((item)=>Number(item.ai_count || 0)),
                barWidth: (safeList === null || safeList === void 0 ? void 0 : safeList.length) < 14 ? 40 : 'auto',
                itemStyle: {
                    color: '#FFC92F'
                },
                label: {
                    show: true,
                    position: 'inside',
                    formatter: (params)=>{
                        return params.value === 0 ? '' : params.value;
                    }
                }
            },
            /** 人工处理（上层） */ {
                name: t('c_a_processing_quantity'),
                type: 'bar',
                stack: 'total',
                data: safeList.map((item)=>Number(item.human_count || 0)),
                itemStyle: {
                    color: '#6CE565',
                    borderRadius: [
                        6,
                        6,
                        0,
                        0
                    ]
                },
                barWidth: (safeList === null || safeList === void 0 ? void 0 : safeList.length) < 14 ? 40 : 'auto',
                label: {
                    show: true,
                    position: 'inside',
                    formatter: (params)=>{
                        return params.value === 0 ? '' : params.value;
                    }
                }
            },
            /** AI解决率 */ {
                name: t('c_a_overview_ai_solution_rate'),
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                    color: '#8B5CF6'
                },
                smooth: true,
                areaStyle: {
                    color: 'rgba(139, 92, 246, 0.05)'
                },
                data: safeList.map((item)=>Number(String(item.ai_solve_percent).replace('%', '') || 0)),
                label: {
                    show: true,
                    formatter: (params)=>{
                        return params.value === 0 ? '' : `${params.value}%`;
                    }
                }
            }
        ]
    };
};
export const getWaybillOption = (list, t)=>{
    const safeList = list || [];
    return {
        tooltip: {
            trigger: 'axis',
            formatter: (params)=>{
                var _params_;
                const item = safeList === null || safeList === void 0 ? void 0 : safeList[params === null || params === void 0 ? void 0 : (_params_ = params[0]) === null || _params_ === void 0 ? void 0 : _params_.dataIndex];
                if (!item) return '';
                const row = (label, value)=>`
			<div style="display:flex;justify-content:space-between;margin-bottom:4px">
				<span>${label}</span>
				<span style="min-width:100px;text-align:right;font-weight:600">
					${value}
				</span>
			</div>
		`;
                return `
			<div>
				<div style="font-weight:600;margin-bottom:8px;">
					${dayjs(item.date).format('YYYY-MM-DD')}
				</div>
				${row(t('c_a_check_waybill'), item.waybill_count || 0)}
				${row(t('c_a_waybill_rate'), item.waybill_percent || '0%')}
			</div>
		`;
            }
        },
        legend: {},
        grid: {
            left: 10,
            right: 20,
            bottom: 10,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: safeList.map((item)=>dayjs(item.date).format('MM.DD'))
        },
        yAxis: [
            {
                type: 'value',
                name: t('c_a_Incoming_line_statistics'),
                min: 0,
                position: 'left',
                axisLabel: {
                    formatter: '{value}'
                },
                splitLine: {
                    show: true
                },
                nameGap: 24,
                nameTextStyle: {
                    padding: [
                        0,
                        0,
                        10,
                        0
                    ]
                }
            },
            {
                type: 'value',
                name: t('c_a_overview_ai_solution_rate'),
                min: 0,
                position: 'right',
                axisLabel: {
                    formatter: '{value}%'
                },
                splitLine: {
                    show: false
                },
                nameGap: 24,
                nameTextStyle: {
                    padding: [
                        0,
                        0,
                        10,
                        0
                    ]
                }
            }
        ],
        series: [
            /** 运单数量） */ {
                name: t('c_a_check_waybill'),
                type: 'bar',
                data: safeList.map((item)=>Number(item.waybill_count || 0)),
                itemStyle: {
                    color: '#FFC92F',
                    borderRadius: [
                        6,
                        6,
                        0,
                        0
                    ]
                },
                barWidth: (safeList === null || safeList === void 0 ? void 0 : safeList.length) < 14 ? 40 : 'auto',
                label: {
                    show: true,
                    position: 'inside',
                    // color: '#FFF',
                    formatter: (params)=>{
                        return params.value === 0 ? '' : params.value;
                    }
                }
            },
            /** 运单率 */ {
                name: t('c_a_waybill_rate'),
                type: 'line',
                yAxisIndex: 1,
                smooth: true,
                itemStyle: {
                    color: '#8B5CF6'
                },
                areaStyle: {
                    color: 'rgba(139, 92, 246, 0.05)'
                },
                data: safeList.map((item)=>Number(String(item.waybill_percent).replace('%', '') || 0)),
                label: {
                    show: true,
                    formatter: (params)=>{
                        return params.value === 0 ? '' : `${params.value}%`;
                    }
                }
            }
        ]
    };
};
